type BannerSource = { mediaUrl: string; mobileMediaUrl?: string };
type OptimizedMedia = { mobile: string; desktop: string; poster: string; mobileWebm?: string };

/** Only use an optimized asset while its original URL still matches the admin selection. */
export function getBannerPlayback(banner: BannerSource, compact: boolean, media: Record<string, OptimizedMedia>, modernCodec = false) {
  const original = compact && banner.mobileMediaUrl ? banner.mobileMediaUrl : banner.mediaUrl;
  const variant = media[original];
  return { src: variant ? (compact ? (modernCodec && variant.mobileWebm || variant.mobile) : variant.desktop) : original, poster: variant?.poster };
}
